import styled from 'styled-components';
import ds from 'designsystem';
import { media } from 'designsystem/index';

const MobileNavSections = styled.div`
  display: block;
  padding-top: ${ds.get('metrics.base')};
  padding-bottom: ${ds.get('metrics.s')};
  margin-top: auto;
  margin-bottom: auto;
  ${media.mobile`
    align-self: ${({ list }) => (list ? 'flex-start' : 'center')};
    margin-left: ${({ list }) => (list ? '100px' : '0px')};
  `};
`;

export default MobileNavSections;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/MobileNavigation/MobileNavSections.jsx